import { push } from 'connected-react-router'
import camelcaseKeys from 'camelcase-keys'

import { setFlashMessage } from '../actions/flashActions'
import { sessionCreateNoRedirect } from './sessionActions'

import reserveApi from '../utils/axios'
import store from '../store'

const apiValues = availabilityRequest => ({
  email: availabilityRequest.email,
  facility_id: availabilityRequest.facilityId,
  date_start: availabilityRequest.dateStart,
  date_end: availabilityRequest.dateEnd,
  stay_length: availabilityRequest.stayLength,
  sewer: availabilityRequest.sewer,
  water: availabilityRequest.water,
  pullthru: availabilityRequest.pullthru,
  min_length: availabilityRequest.minLength,
  min_electric: availabilityRequest.minElectric,
  site_premium: availabilityRequest.sitePremium,
  ignore_ada: availabilityRequest.ignoreAda,
  site_type: availabilityRequest.type,
  specific_site_ids: availabilityRequest.specificSiteIds,
  arrival_days: availabilityRequest.arrivalDays,
  pets_allowed: availabilityRequest.petsAllowed
})

export function matchingSiteCount(values) {
  return function (dispatch) {
    reserveApi({
      method: 'post',
      url: '/availability_requests/sites_count.json',
      data: {
        availability_request: apiValues(values)
      }
    })
      .then(response => {
        dispatch({
          type: 'FETCH_AR_SITE_COUNT_FULFILLED',
          payload: camelcaseKeys(response.data, { deep: true })
        })
      })
      .catch(err => {
        dispatch({ type: 'SUBMIT_REQUEST_REJECTED', payload: err })
      })
  }
}

export function formSubmit(values) {
  return function (dispatch) {
    dispatch({ type: 'SUBMIT_REQUEST_FORM' })
    return reserveApi({
      method: 'post',
      url: '/availability_requests.json',
      data: {
        availability_request: apiValues(values)
      }
    })
      .then(response => {
        dispatch({ type: 'SUBMIT_REQUEST_FORM_SUCCESS' })
        dispatch({ type: 'FETCH_AR_FULFILLED', payload: response.data })
        dispatch({ type: 'ARS_RESET' })

        if (response.data.new_account) {
          dispatch(sessionCreateNoRedirect(response.data.uuid))
        }

        dispatch(push(`/${response.data.uuid}`))
        dispatch(setFlashMessage('Success!! We will email you if a site becomes available.', 'success'))
      })
      .catch(err => {
        console.log('err', err.response.data)
        dispatch({ type: 'SUBMIT_REQUEST_REJECTED', payload: err.response.data })
      })
  }
}

export function formUpdate(values, redirect = false) {
  return function (dispatch) {
    dispatch({ type: 'SUBMIT_REQUEST_FORM' })
    const uuid = values.uuid

    return reserveApi({
      method: 'put',
      url: `/availability_requests/${uuid}.json`,
      data: { availability_request: apiValues(values) }
    })
      .then(response => {
        dispatch({ type: 'SUBMIT_REQUEST_FORM_SUCCESS' })
        dispatch({ type: 'FETCH_AR_FULFILLED', payload: response.data })
        if (redirect) {
          dispatch(push(`/${response.data.uuid}`))
          dispatch(setFlashMessage('Request Updated!! We will email you if a site becomes available.', 'success'))
        }
      })
      .catch(err => {
        dispatch({ type: 'SUBMIT_REQUEST_REJECTED', payload: err })
      })
  }
}

export function calendarFacilityFetch(availabilityRequest, color) {
  return function (dispatch) {
    reserveApi({
      method: 'post',
      url: `/availability_requests/calendar.json`,
      data: {
        availability_request: apiValues(availabilityRequest)
      }
    })
      .then(response => {
        dispatch({
          type: 'CALENDAR_FACILITY_FULFILLED',
          payload: { ...response.data, color }
        })
      })
      .catch(err => {
        dispatch({ type: 'CALENDAR_FACILITY_REJECTED', payload: err })
      })
  }
}

export function formStepInc() {
  return function (dispatch) {
    let current_step = store.getState().requestForm.step

    let newStep = current_step + 1
    dispatch(formStepGo(newStep > 4 ? 4 : newStep))
  }
}

export function formStepDec() {
  return function (dispatch) {
    let current_step = store.getState().requestForm.step

    let newStep = current_step - 1
    dispatch(formStepGo(newStep < 1 ? 1 : newStep))
  }
}

export function formStepGo(step) {
  return function (dispatch) {
    dispatch({ type: 'FORM_STEP_GO', payload: step })
    window.scrollTo(0, 0)
    return Promise.resolve()
  }
}

export function formStepGoOld(step) {
  return function (dispatch) {
    let currentStep = store.getState().requestForm.step
    // dispatch(formStepValidate())
    const stepValid = store.getState().forms.availabilityRequestForm.$form.valid

    if (!stepValid && step >= currentStep && currentStep !== 1) {
      return
    }

    const uuid = store.getState().availabilityRequestForm.uuid
    if (uuid && step === 1) {
      return
    }
    if (uuid && step === 4) {
      dispatch(formUpdate(true))
      return
    }

    if (step > currentStep) {
      dispatch({ type: 'FORM_STEP_GO', payload: step }) && dispatch(matchingSiteCount())
      window.scrollTo(0, 0)
      uuid && dispatch(formUpdate())
    } else {
      dispatch({ type: 'FORM_STEP_GO', payload: step })
      window.scrollTo(0, 0)
    }
  }
}

export function siteSelectorToggle() {
  return function (dispatch) {
    const siteSelector = store.getState().requestForm.siteSelector
    dispatch({ type: 'SITE_SELECTOR', payload: !siteSelector })
  }
}

export function formClone(availabilityRequest) {
  return function (dispatch) {
    dispatch({ type: 'REQUEST_FORM_CLONE', payload: true })
    dispatch(push(`/new/${availabilityRequest.facilityId}`))
  }
}
